module.exports = __webpack_public_path__ + "img/cpaider-down-leads.111a8eaa.svg";